/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".glyphicon-refresh-animate[_ngcontent-%COMP%]{-animation:spin .7s infinite linear;-webkit-animation:.7s linear infinite spin2}@-webkit-keyframes spin2{from{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(360deg)}}@-webkit-keyframes spin{from{-webkit-transform:scale(1) rotate(0);transform:scale(1) rotate(0)}to{-webkit-transform:scale(1) rotate(360deg);transform:scale(1) rotate(360deg)}}@keyframes spin{from{-webkit-transform:scale(1) rotate(0);transform:scale(1) rotate(0)}to{-webkit-transform:scale(1) rotate(360deg);transform:scale(1) rotate(360deg)}}\n/*# sourceMappingURL=spin-icon.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/spin-icon/spin-icon.component.css.shim.ngstyle.js.pre-build-optimizer.js